<template>
  <div>
    <h3>评论列表</h3>
    <el-table :data="tableData" border>
      <el-table-column prop="id" label="评论ID"/>
      <el-table-column prop="postId" label="帖子ID"/>
      <el-table-column prop="content" label="评论内容"/>
      <el-table-column prop="createdAt" label="时间"/>
    </el-table>
  </div>
</template>
<script>
import {getCommentList} from "../api";
export default {
  data(){return {tableData:[]}},
  mounted(){
    this.load()
  },
  methods:{
    async load(){
      const res = await getCommentList()
      this.tableData = res.data.list
    }
  }
}
</script>
